import React, { useEffect, useState } from "react";
import teamData from "../../assets/teamData.json";
import "./Recognisiton.css";
import { TeamMember, images } from "../../models/common/TeamMember";
import timelineData from "../../assets/timelineData.json";

import recognitionData from "../../assets/recognitionData.json";
import bcic from "../../assets/img/aboutus/bcic.png";
import startup from "../../assets/img/aboutus/startup.png"; 



const imageMap: Record<string, string> = {
  bcic,
  startup
};


const AboutUsComponent: React.FC = () => {

  const [team, setTeam] = useState<TeamMember[]>([]);

  useEffect(() => {
    setTeam(teamData as TeamMember[]);
  }, []);

  return (
    <div className="aboutUsBlock">
      <div className="aboutus-hero-banner">
        <div className="container">
          <h1>About Us</h1>
        </div>
      </div>
      <div className="container">
        <div className="aboutUsBlock-content">
          <p>
            IamInterviewed is a platform designed to simplify technical
            interviews. It enables companies to identify the right talent with
            minimal efforts, reducing both time and cost in the hiring process.
            We aim to bridge the gap between the candidate and recruiter, by
            conducting interviews on behalf of the company and grading
            candidates as per their technical skills.
          </p>
          <h2 className="section-title">The Journey</h2>
          <p>
            In 2016, IamInterviewed embarked on a mission to revolutionise the
            way technical interviews are conducted, becoming the first platform
            of its kind.
          </p>
        </div>

        <div className="aboutUsBlock-content mt-10">
          <h2 className="section-title"> IamInterviewed Growth Chronicle</h2>
          <section className="timeline">
            <div className="container">
              {timelineData.map((item, index) => (
                <div className="timeline-item" key={index}>
                  <div className="timeline-img"></div>
                  <div className="timeline-content">
                    <div className="date">{item.year}</div>
                    <blockquote className="events">{item.event}</blockquote>
                  </div>
                </div>
              ))}
            </div>
          </section>
        </div>
      </div>
      <section className="team-section">
        <div className="container">
          <h2 className="section-title">Our Leadership Team</h2>
          <div className="row justify-content-center gy-4">
             
            {team.slice(0, 2).map((member) => (
              <div
                key={member.id}
                className="col-md-6 d-flex justify-content-center"
              >
                <div className="team-card p-3">
                  <div className="team-img">
                    <img src={images[member.image]} alt={member.name} loading="lazy" />
                    <div className="overlay">
                      <a href={member.links.email}>
                        <i className="fas fa-envelope"></i>
                      </a>
                      <a href={member.links.linkedin}>
                        <i className="fab fa-linkedin"></i>
                      </a>
                      <a href={member.links.twitter}>
                        <i className="fab fa-twitter"></i>
                      </a>
                    </div>
                  </div>

                  <h5 className="team-name">{member.name}</h5>
                  <p className="team-role">{member.role}</p>

                  <input
                    type="checkbox"
                    id={`readmore${member.id}`}
                    className="read-more-toggle"
                  />
                  <div className="desc-wrapper">
                    <p className="team-desc">{member.desc}</p>
                  </div>
                  <label
                    htmlFor={`readmore${member.id}`}
                    className="read-more-label"
                  ></label>
                </div>
              </div>
            ))}
          </div>
          <h2 className="section-title mt-4">Advisors and Investors</h2>
          <div className="row justify-content-center gy-4">
            
            {team.slice(2).map((member) => (
              <div
                key={member.id}
                className="col-md-4 d-flex justify-content-center"
              >
                <div className="team-card p-3">
                  <div className="team-img">
                    <img src={images[member.image]} alt={member.name} loading="lazy" />
                    <div className="overlay">
                      <a href={member.links.email}>
                        <i className="fas fa-envelope"></i>
                      </a>
                      <a href={member.links.linkedin}>
                        <i className="fab fa-linkedin"></i>
                      </a>
                      <a href={member.links.twitter}>
                        <i className="fab fa-twitter"></i>
                      </a>
                    </div>
                  </div>

                  <h5 className="team-name">{member.name}</h5>
                  <p className="team-role">{member.role}</p>

                  <input
                    type="checkbox"
                    id={`readmore${member.id}`}
                    className="read-more-toggle"
                  />
                  <div className="desc-wrapper">
                    <p className="team-desc">{member.desc}</p>
                  </div>
                  <label
                    htmlFor={`readmore${member.id}`}
                    className="read-more-label"
                  ></label>
                </div>
              </div>
            ))}
          </div>


        </div>
      </section>
      <div className="recognition-wrapper">
        <div className="bg-shape shape1"></div>
        <div className="bg-shape shape2"></div>
        <div className="container">
          <section className="recognition-section">
            <div className="container">
              <h2 className="section-title">Recognition</h2>
              <p className="section-description">
                Since its inception, IamInterviewed has conducted over 3,80,000 interviews,
                connecting talent with opportunities. With 370+ companies, a team of
                3200+ interviewers, and a global presence across 4 continents,
                we are a trusted partner in recruitment. Today, interview rounds can be
                seamlessly conducted in under 24 hours, making the hiring process faster
                and more efficient.
              </p>

              <div className="recognition-cards">
                {recognitionData.map((item) => (
                  <div className="recog-card" key={item.id}>
                    <div className="recog-img-wrapper">
                      <img
                        src={imageMap[item.image]}
                        alt={item.alt}
                        className="recog-img"
                      />
                    </div>
                    <h3 className="recog-title">{item.title}</h3>
                    <p className="recog-text">{item.text}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};
export default AboutUsComponent;
